module.exports = __webpack_public_path__ + "img/icon_room_manager.f072c698.png";